var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card"},[_c('b',[_vm._v("Overview")]),_vm._v(" "),_c('KPIsCalendar',{ref:"kpi_calendar",attrs:{"overall_res":_vm.overall_res},on:{"on_prev":_vm.onPrev,"on_next":_vm.onNext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }